import styled from "styled-components";
import App from "../constants/app";

export const SideBarContainer = styled.div`
  display: flex;
  position: ${props => (props.fixed ? "fixed" : "static")};
  width: ${props =>
    props.minimize ? App.SIDEBAR_MIN_WIDTH : App.SIDEBAR_WIDTH};
  bottom: ${props => props.footerHeight || App.FOOTER_HEIGHT};
  top: ${props => props.headerHeight || "0"};
  background-color: ${props => props.theme.sideBar.background};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  will-change: transition;
  flex: 0 0 auto;

  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;

  &.visible {
    left: ${props => (props.left ? "0" : "auto")};
    right: ${props => (props.right ? "0" : "auto")};
  }
  &.hidden {
    left: ${props => (props.left ? "-5rem" : "auto")};
    right: ${props => (props.right ? "-5rem" : "auto")};
  }
`;

export const SideBarInner = styled.ul`
  list-style-type: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./app/styled-components/SideBar.js